import React from 'react'
import KeyBenefitsOfTradingSection from '../../sections/KeyBenefitsOfTradingSection'
import { IconsGridSliceProps } from './types'

const IconsGridSlice: React.FC<IconsGridSliceProps> = ({ slice }) => {
  const { ig_title, ig_description, ig_is_main_heading } = slice.primary || {}

  return (
    <KeyBenefitsOfTradingSection
      heading={ig_title?.text}
      isHeadingGreen={true}
      isMainHeading={ig_is_main_heading}
      headingPadding={['80px', '', '100px']}
      description={ig_description?.html}
      inner="inners.primary"
      paddingTop={['20px', '', '70px']}
      paddingBottom={['10px', '', '0']}
      data={(slice.items || []).map((item, index) => {
        const { ig_icon, ig_icon_title = '' } = item || {}

        return {
          key: `${index}`,
          icon: ig_icon,
          title: ig_icon_title
        }
      })}
    />
  )
}

export default IconsGridSlice
